import { Component, NgModule, Output, Input, EventEmitter, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DxTreeViewModule, DxTreeViewComponent } from 'devextreme-angular/ui/tree-view';

import * as events from 'devextreme/events';
import { leftMenuService, navigation, produttori } from '../../app-navigation';
import { MessaggioComponent, MessaggioModule } from '../messaggio/messaggio.component';


@Component({
  selector: 'app-side-navigation-menu',
  templateUrl: './side-navigation-menu.component.html',
  styleUrls: ['./side-navigation-menu.component.scss']
})
export class SideNavigationMenuComponent implements AfterViewInit, OnDestroy {
  @ViewChild(DxTreeViewComponent, { static: true })
  menu: DxTreeViewComponent;
  @Input() apiMenu;
  @Output()
  selectedItemChanged = new EventEmitter<string>();

  @Output()
  openMenu = new EventEmitter<any>();

  private _selectedItem: String;
  @Input()
  set selectedItem(value: String) {
    this._selectedItem = value;
    if (!this.menu.instance) {
      return;
    }

    this.menu.instance.selectItem(value);
  }

  pippo:  MessaggioComponent;
  public _items;/*
  get items() {
   if (this.apiMenu){
    if (!this._items) {
        let dati = this.myDati.getService(this.apiMenu);
        console.log(dati);
    //  this._items = navigation.map((item) => ({ ...item, expanded: !this._compactMode }));
        this._items = dati.map((item) =>({...item, expanded:!this._compactMode}));
    }

    return this._items;}
  }*/

  private _compactMode = false;
  @Input()
  get compactMode() {
    return this._compactMode;
  }
  set compactMode(val) {
    this._compactMode = val;

    if (!this.menu.instance) {
      return;
    }

    if (val) {
      this.menu.instance.collapseAll();
    } else {
      this.menu.instance.expandItem(this._selectedItem);
    }
  }

  constructor(private elementRef: ElementRef, private myDati: leftMenuService) {




}

  onItemClick(event) {
    this.selectedItemChanged.emit(event);
  }

  ngAfterViewInit() {

  if (this.apiMenu){
    console.log('entro')
    if (!this._items) {
        let dati = this.myDati.getService(this.apiMenu);
        console.log(dati);
    //  this._items = navigation.map((item) => ({ ...item, expanded: !this._compactMode }));
        this._items = dati.map((item) =>({...item, expanded:!this._compactMode}));

    }

    return this._items;}
    events.on(this.elementRef.nativeElement, 'dxclick', (e) => {
      this.openMenu.next(e);
    });

  }

  ngOnDestroy() {
    events.off(this.elementRef.nativeElement, 'dxclick');
  }
}

@NgModule({
  imports: [ DxTreeViewModule ],
  declarations: [ SideNavigationMenuComponent ],
  exports: [ SideNavigationMenuComponent ]
})
export class SideNavigationMenuModule { }
